import React from 'react';
import { CheckCircleFilled, LoadingOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import { equals, map } from 'ramda';
import Section from './Section';

const OperationStatusSection = ({ operationType, items, status, progress, errorMsg, showError, displayValue = false }) => {
  const statusItem = (type) =>
    displayValue
      ? <p>{status[type]}</p>
      : status[type] ? <CheckCircleFilled className="!text-flexi-valid" /> : <LoadingOutlined />;

  return (
    <Section
      className="shadow-none"
      classNameTitle="text-flexi-primary-color"
      title={`Compte rendu de ${operationType}`}
    >
      {map(({ label, type }) => (
        <div className="flex justify-between" key={type}>
          <p>{label}</p>
          {statusItem(type)}
        </div>
      ))(items)}
      {equals(100, progress) && showError && (
        <Alert type="error" message={<p>{errorMsg}</p>} />
      )}
    </Section>
  );
};

export default OperationStatusSection;
